var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "research-gene-set-utility" }, [
    !_vm.hideButtons
      ? _c(
          "div",
          {
            staticClass: "utility-actions",
            staticStyle: {
              display: "flex",
              gap: "10px",
              "margin-bottom": "15px",
            },
          },
          [
            !_vm.showOnlyGroupAndTier
              ? _c("div", { staticClass: "button-with-tooltip" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      staticStyle: {
                        padding: "8px 16px",
                        display: "flex",
                        "align-items": "center",
                        gap: "6px",
                      },
                      attrs: { disabled: !_vm.canGenerateScores },
                      on: { click: _vm.openScoreDialog },
                    },
                    [
                      _c("span", [
                        _vm._v("Score genes for relevance and novelty"),
                      ]),
                      _c("span", { staticClass: "info-icon" }, [
                        _vm._v(" ℹ️ "),
                      ]),
                    ]
                  ),
                  _vm._m(0),
                ])
              : _vm._e(),
            !_vm.showOnlyGroupAndTier
              ? _c("div", { staticClass: "button-with-tooltip" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      staticStyle: {
                        padding: "8px 16px",
                        display: "flex",
                        "align-items": "center",
                        gap: "6px",
                      },
                      attrs: { disabled: !_vm.canRankGenes },
                      on: { click: _vm.openRankDialog },
                    },
                    [
                      _c("span", [_vm._v("Filter, Score, and Rank Genes")]),
                      _c("span", { staticClass: "info-icon" }, [
                        _vm._v(" ℹ️ "),
                      ]),
                    ]
                  ),
                  _vm._m(1),
                ])
              : _vm._e(),
            _vm.canGroupGenes
              ? _c("div", { staticClass: "button-with-tooltip" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-group",
                      staticStyle: {
                        padding: "8px 16px",
                        display: "flex",
                        "align-items": "center",
                        gap: "6px",
                      },
                      on: { click: _vm.openGroupDialog },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.showOnlyGroupAndTier
                              ? "Group and Tier Genes (Optional)"
                              : "Group and Tier Selected Genes"
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "info-icon" }, [
                        _vm._v(" ℹ️ "),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "tooltip tooltip-group" }, [
                    _c("div", { staticClass: "tooltip-content" }, [
                      _c("h5", [
                        _vm._v(
                          _vm._s(
                            _vm.showOnlyGroupAndTier
                              ? "Group and Tier Genes (Optional)"
                              : "Group and Tier Selected Genes"
                          )
                        ),
                      ]),
                      _vm._m(2),
                      _vm._m(3),
                      _vm._m(4),
                      _vm._m(5),
                      _vm._m(6),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.showOnlyGroupAndTier && _vm.showReviewButton
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    staticStyle: { padding: "8px 16px" },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("review-generate")
                      },
                    },
                  },
                  [_vm._v(" Review & Generate Experiment Plan ")]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm.showScoreDialog
      ? _c(
          "div",
          {
            staticClass: "dialog-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeScoreDialog.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "dialog-container" }, [
              _c("div", { staticClass: "dialog-header" }, [
                _c("h3", [_vm._v("Gene Relevance & Novelty Scoring")]),
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: { click: _vm.closeScoreDialog },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _c("div", { staticClass: "dialog-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "research-context-section",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _vm._m(7),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.scoreResearchContext,
                          expression: "scoreResearchContext",
                        },
                      ],
                      staticClass: "hypothesis-textarea",
                      attrs: {
                        placeholder: "Enter your research context...",
                        rows: "3",
                      },
                      domProps: { value: _vm.scoreResearchContext },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.scoreResearchContext = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-section",
                    staticStyle: {
                      "margin-bottom": "20px",
                      padding: "15px",
                      background: "#f8f9fa",
                      "border-radius": "6px",
                    },
                  },
                  [
                    _c("h4", [_vm._v("Hypothesis")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.hypothesis || "No hypothesis provided")
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-section",
                    staticStyle: {
                      "margin-bottom": "20px",
                      padding: "15px",
                      background: "#f8f9fa",
                      "border-radius": "6px",
                    },
                  },
                  [
                    _c("h4", [_vm._v("Genes")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [_vm._v(_vm._s(_vm.genesDisplay))]
                    ),
                  ]
                ),
                _vm.isGeneratingScores || _vm.isQueryingAnyPage
                  ? _c(
                      "div",
                      {
                        staticClass: "loading-indicator",
                        staticStyle: {
                          "margin-bottom": "20px",
                          padding: "12px",
                          background: "#e3f2fd",
                          "border-left": "3px solid #1976d2",
                          "border-radius": "4px",
                        },
                      },
                      [
                        _c("span", { staticClass: "loading-spinner-small" }),
                        _c("span", [
                          _vm._v(
                            "Generating scores" +
                              _vm._s(
                                _vm.isQueryingAnyPage
                                  ? ` for page ${Array.from(
                                      _vm.queryingPages
                                    ).join(", ")}`
                                  : ` for page ${_vm.scoredGenesCurrentPage}`
                              ) +
                              "... (" +
                              _vm._s(_vm.scoreElapsedTime) +
                              ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.genes.length > 0
                  ? _c("div", { staticClass: "table-section" }, [
                      _vm._m(8),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-bottom": "10px",
                            display: "flex",
                            "align-items": "center",
                            gap: "8px",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "8px",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.showOnlySelectedScoredGenes,
                                    expression: "showOnlySelectedScoredGenes",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "showOnlySelectedScoredGenes",
                                  disabled:
                                    _vm.selectedScoredGenes.length === 0,
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.showOnlySelectedScoredGenes
                                  )
                                    ? _vm._i(
                                        _vm.showOnlySelectedScoredGenes,
                                        null
                                      ) > -1
                                    : _vm.showOnlySelectedScoredGenes,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.showOnlySelectedScoredGenes,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.showOnlySelectedScoredGenes =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.showOnlySelectedScoredGenes = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.showOnlySelectedScoredGenes = $$c
                                    }
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "13px",
                                    color: "#333",
                                    cursor: "pointer",
                                  },
                                  attrs: { for: "showOnlySelectedScoredGenes" },
                                },
                                [_vm._v(" Show only selected ")]
                              ),
                              _vm.selectedScoredGenes.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        color: "#666",
                                        "margin-left": "8px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " (" +
                                          _vm._s(
                                            _vm.selectedScoredGenes.length
                                          ) +
                                          " selected) "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              staticStyle: {
                                padding: "6px 12px",
                                "font-size": "13px",
                              },
                              attrs: {
                                disabled: _vm.selectedScoredGenes.length === 0,
                              },
                              on: { click: _vm.downloadScoredGenes },
                            },
                            [_vm._v(" Download Selected Genes ")]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "table-container" }, [
                        _c("table", { staticClass: "gene-data-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "40px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "selectAllScoredGenesCheckbox",
                                    attrs: {
                                      type: "checkbox",
                                      indeterminate:
                                        _vm.someScoredGenesSelected(),
                                    },
                                    domProps: {
                                      checked: _vm.allScoredGenesSelected(),
                                    },
                                    on: { change: _vm.toggleAllScoredGenes },
                                  }),
                                ]
                              ),
                              _c("th", [_vm._v("Gene")]),
                              _c("th", [_vm._v("Classification")]),
                              _c("th", [_vm._v("Relevance Score")]),
                              _c("th", [_vm._v("Novelty Score")]),
                              _c("th", { staticStyle: { width: "30%" } }, [
                                _vm._v("Reason"),
                              ]),
                              _c("th", { staticStyle: { width: "30%" } }, [
                                _vm._v("Hypothesis Validation"),
                              ]),
                              _c("th", [_vm._v("IDG Novelty")]),
                              _c("th", [_vm._v("IDG Evidence")]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.scoredGenesTableRows, function (row) {
                                return [
                                  row.type === "scored"
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.key,
                                          class: {
                                            "selected-row":
                                              _vm.isScoredGeneSelected(
                                                row.scoredGene.gene
                                              ),
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "10px 8px",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                                "text-align": "center",
                                              },
                                            },
                                            [
                                              _c("input", {
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked:
                                                    _vm.isScoredGeneSelected(
                                                      row.scoredGene.gene
                                                    ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.toggleScoredGeneSelection(
                                                      row.scoredGene.gene
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                color: "#333",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.scoredGene.gene || "N/A"
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("td", [
                                            row.scoredGene.isScoring
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#999",
                                                      "font-style": "italic",
                                                    },
                                                  },
                                                  [_vm._v(" Loading... ")]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#666",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.scoredGene
                                                          .classification ||
                                                          "N/A"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                          _c("td", [
                                            row.scoredGene.isScoring
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#999",
                                                      "font-style": "italic",
                                                    },
                                                  },
                                                  [_vm._v(" Loading... ")]
                                                )
                                              : row.scoredGene
                                                  .relevance_score !==
                                                  undefined &&
                                                row.scoredGene
                                                  .relevance_score !== null &&
                                                row.scoredGene
                                                  .relevance_score !== "N/A"
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "high-score":
                                                        (typeof row.scoredGene
                                                          .relevance_score ===
                                                        "number"
                                                          ? row.scoredGene
                                                              .relevance_score
                                                          : parseFloat(
                                                              row.scoredGene
                                                                .relevance_score
                                                            )) >= 7,
                                                    },
                                                    staticStyle: {
                                                      "font-weight": "600",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.scoredGene
                                                            .relevance_score
                                                        ) +
                                                        _vm._s(
                                                          typeof row.scoredGene
                                                            .relevance_score ===
                                                            "number" ||
                                                            (typeof row
                                                              .scoredGene
                                                              .relevance_score ===
                                                              "string" &&
                                                              !isNaN(
                                                                parseFloat(
                                                                  row.scoredGene
                                                                    .relevance_score
                                                                )
                                                              ))
                                                            ? "/10"
                                                            : ""
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("N/A")]),
                                          ]),
                                          _c("td", [
                                            row.scoredGene.isScoring
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#999",
                                                      "font-style": "italic",
                                                    },
                                                  },
                                                  [_vm._v(" Loading... ")]
                                                )
                                              : row.scoredGene.novelty_score !==
                                                  undefined &&
                                                row.scoredGene.novelty_score !==
                                                  null &&
                                                row.scoredGene.novelty_score !==
                                                  "N/A"
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "high-score":
                                                        (typeof row.scoredGene
                                                          .novelty_score ===
                                                        "number"
                                                          ? row.scoredGene
                                                              .novelty_score
                                                          : parseFloat(
                                                              row.scoredGene
                                                                .novelty_score
                                                            )) >= 7,
                                                    },
                                                    staticStyle: {
                                                      "font-weight": "600",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.scoredGene
                                                            .novelty_score
                                                        ) +
                                                        _vm._s(
                                                          typeof row.scoredGene
                                                            .novelty_score ===
                                                            "number" ||
                                                            (typeof row
                                                              .scoredGene
                                                              .novelty_score ===
                                                              "string" &&
                                                              !isNaN(
                                                                parseFloat(
                                                                  row.scoredGene
                                                                    .novelty_score
                                                                )
                                                              ))
                                                            ? "/10"
                                                            : ""
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("N/A")]),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "reason-cell" },
                                              [
                                                row.scoredGene.isScoring
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#999",
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : row.scoredGene.reason
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reason-content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              row.scoredGene
                                                                .reason
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "reason-cell" },
                                              [
                                                row.scoredGene.isScoring
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#999",
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : row.scoredGene
                                                      .hypothesis_validation
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reason-content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              row.scoredGene
                                                                .hypothesis_validation
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "td",
                                            [
                                              row.scoredGene.idg_tdl
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: _vm.getTDLClass(
                                                          row.scoredGene.idg_tdl
                                                        ),
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          padding: "4px 10px",
                                                          "border-radius":
                                                            "4px",
                                                          "font-weight": "600",
                                                          "font-size": "11px",
                                                          color: "white",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            row.scoredGene
                                                              .idg_tdl
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : row.scoredGene.idg_fetched
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [_vm._v("N/A")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [_vm._v("Loading...")]
                                                  ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "10px 8px",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                                "text-align": "center",
                                              },
                                            },
                                            [
                                              row.scoredGene.idg_fullData
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "idg-view-button",
                                                      class: {
                                                        active:
                                                          _vm.expandedScoredGenesIDG.includes(
                                                            row.scoredGene.gene
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleScoredGeneIDGEvidenceView(
                                                            row.scoredGene.gene
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.expandedScoredGenesIDG.includes(
                                                              row.scoredGene
                                                                .gene
                                                            )
                                                              ? "Hide"
                                                              : "View"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : row.scoredGene.idg_fetched ===
                                                  false
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("Loading...")]
                                                  )
                                                : row.scoredGene.idg_fetched ===
                                                  true
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("N/A")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  row.type === "idg-evidence"
                                    ? _c("tr", { key: row.key }, [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              padding: "0",
                                              "border-bottom":
                                                "1px solid #dee2e6",
                                            },
                                            attrs: { colspan: 9 },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "idg-evidence-subtable",
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "idg-evidence-table",
                                                  },
                                                  [
                                                    _vm._m(9, true),
                                                    _c("tbody", [
                                                      _c("tr", [
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.scoredGene
                                                                .idg_fullData
                                                                .sym || "N/A"
                                                            )
                                                          ),
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.scoredGene
                                                                .idg_fullData
                                                                .name || "N/A"
                                                            )
                                                          ),
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.scoredGene
                                                                .idg_fullData
                                                                .fam || "N/A"
                                                            )
                                                          ),
                                                        ]),
                                                        _c("td", [
                                                          row.scoredGene
                                                            .idg_fullData.tdl
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  class:
                                                                    _vm.getTDLClass(
                                                                      row
                                                                        .scoredGene
                                                                        .idg_fullData
                                                                        .tdl
                                                                    ),
                                                                  staticStyle: {
                                                                    display:
                                                                      "inline-block",
                                                                    padding:
                                                                      "4px 10px",
                                                                    "border-radius":
                                                                      "4px",
                                                                    "font-weight":
                                                                      "600",
                                                                    "font-size":
                                                                      "11px",
                                                                    color:
                                                                      "white",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        row
                                                                          .scoredGene
                                                                          .idg_fullData
                                                                          .tdl
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v("N/A"),
                                                              ]),
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.scoredGene
                                                                .idg_fullData
                                                                .description ||
                                                                "N/A"
                                                            )
                                                          ),
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.scoredGene
                                                                .idg_fullData
                                                                .novelty ||
                                                                "N/A"
                                                            )
                                                          ),
                                                        ]),
                                                        _c("td", [
                                                          row.scoredGene
                                                            .idg_fullData.sym
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#1976d2",
                                                                    "text-decoration":
                                                                      "none",
                                                                  },
                                                                  attrs: {
                                                                    href: `https://pharos.nih.gov/targets/${row.scoredGene.idg_fullData.sym}`,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Open "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v("N/A"),
                                                              ]),
                                                        ]),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm.scoredGenesTotalPages > 1
                        ? _c("div", { staticClass: "pagination-container" }, [
                            _c("div", { staticClass: "pagination-info" }, [
                              _vm._v(
                                " Showing " +
                                  _vm._s(
                                    (_vm.scoredGenesCurrentPage - 1) *
                                      _vm.itemsPerPage +
                                      1
                                  ) +
                                  " to " +
                                  _vm._s(
                                    Math.min(
                                      _vm.scoredGenesCurrentPage *
                                        _vm.itemsPerPage,
                                      _vm.genes.length
                                    )
                                  ) +
                                  " of " +
                                  _vm._s(_vm.genes.length) +
                                  " entries "
                              ),
                            ]),
                            _c("div", { staticClass: "pagination-controls" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled: _vm.scoredGenesCurrentPage === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToScoredGenesPage(1)
                                    },
                                  },
                                },
                                [_vm._v(" «« ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled: _vm.scoredGenesCurrentPage === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToScoredGenesPage(
                                        _vm.scoredGenesCurrentPage - 1
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Previous ")]
                              ),
                              _c(
                                "span",
                                { staticClass: "page-numbers" },
                                _vm._l(
                                  _vm.visibleScoredGenesPages,
                                  function (page) {
                                    return _c(
                                      "button",
                                      {
                                        key: page,
                                        class: [
                                          "page-btn",
                                          {
                                            active:
                                              page ===
                                              _vm.scoredGenesCurrentPage,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToScoredGenesPage(page)
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(page) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled:
                                      _vm.scoredGenesCurrentPage ===
                                      _vm.scoredGenesTotalPages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToScoredGenesPage(
                                        _vm.scoredGenesCurrentPage + 1
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Next ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled:
                                      _vm.scoredGenesCurrentPage ===
                                      _vm.scoredGenesTotalPages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToScoredGenesPage(
                                        _vm.scoredGenesTotalPages
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" »» ")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "dialog-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: { click: _vm.closeScoreDialog },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm.showRankDialog
      ? _c(
          "div",
          {
            staticClass: "dialog-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeRankDialog.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "dialog-container" }, [
              _c("div", { staticClass: "dialog-header" }, [
                _c("h3", [_vm._v("Gene Ranking")]),
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: { click: _vm.closeRankDialog },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _c("div", { staticClass: "dialog-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "research-context-section",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _vm._m(10),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rankResearchContext,
                          expression: "rankResearchContext",
                        },
                      ],
                      staticClass: "hypothesis-textarea",
                      attrs: {
                        placeholder: "Enter your research context...",
                        rows: "3",
                      },
                      domProps: { value: _vm.rankResearchContext },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.rankResearchContext = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-section",
                    staticStyle: {
                      "margin-bottom": "20px",
                      padding: "15px",
                      background: "#f8f9fa",
                      "border-radius": "6px",
                    },
                  },
                  [
                    _c("h4", [_vm._v("Hypothesis")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.hypothesis || "No hypothesis provided")
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-section",
                    staticStyle: {
                      "margin-bottom": "20px",
                      padding: "15px",
                      background: "#f8f9fa",
                      "border-radius": "6px",
                    },
                  },
                  [
                    _c("h4", [_vm._v("Genes")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [_vm._v(_vm._s(_vm.genesDisplay))]
                    ),
                  ]
                ),
                _vm.isRankingGenes
                  ? _c(
                      "div",
                      {
                        staticClass: "loading-indicator",
                        staticStyle: {
                          "margin-bottom": "20px",
                          padding: "12px",
                          background: "#e3f2fd",
                          "border-left": "3px solid #1976d2",
                          "border-radius": "4px",
                        },
                      },
                      [
                        _c("span", { staticClass: "loading-spinner-small" }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.rankingStep || "Ranking genes...") +
                              " (" +
                              _vm._s(_vm.rankElapsedTime) +
                              ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.rankingError && !_vm.isRankingGenes
                  ? _c(
                      "div",
                      {
                        staticClass: "error-indicator",
                        staticStyle: {
                          "margin-bottom": "20px",
                          padding: "15px",
                          background: "#f8d7da",
                          "border-left": "3px solid #dc3545",
                          "border-radius": "4px",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "10px" } },
                          [
                            _c(
                              "strong",
                              {
                                staticStyle: {
                                  color: "#721c24",
                                  "font-size": "14px",
                                },
                              },
                              [_vm._v("Error during ranking:")]
                            ),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  margin: "8px 0 0 0",
                                  color: "#721c24",
                                  "font-size": "13px",
                                  "line-height": "1.5",
                                },
                              },
                              [_vm._v(_vm._s(_vm.rankingError))]
                            ),
                          ]
                        ),
                        _vm.completedFilterBatches > 0 ||
                        _vm.completedRankBatches > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "10px",
                                  padding: "8px",
                                  background: "#fff",
                                  "border-radius": "4px",
                                },
                              },
                              [
                                _c(
                                  "small",
                                  {
                                    staticStyle: {
                                      color: "#856404",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _vm._v(" Progress: "),
                                    _vm.completedFilterBatches > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "Filtering: " +
                                              _vm._s(
                                                _vm.completedFilterBatches
                                              ) +
                                              "/" +
                                              _vm._s(_vm.totalFilterBatches) +
                                              " batches completed"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.completedFilterBatches > 0 &&
                                    _vm.completedRankBatches > 0
                                      ? _c("span", [_vm._v(" • ")])
                                      : _vm._e(),
                                    _vm.completedRankBatches > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "Ranking: " +
                                              _vm._s(_vm.completedRankBatches) +
                                              "/" +
                                              _vm._s(_vm.totalRankBatches) +
                                              " batches completed"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            staticStyle: {
                              padding: "6px 16px",
                              "font-size": "13px",
                            },
                            on: { click: _vm.resumeRanking },
                          },
                          [_vm._v(" Try Again (Resume) ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.filteringReason
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "20px",
                          padding: "12px",
                          background: "#fff3cd",
                          "border-left": "3px solid #ffc107",
                          "border-radius": "4px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showFilteringReason =
                                  !_vm.showFilteringReason
                              },
                            },
                          },
                          [
                            _c(
                              "strong",
                              {
                                staticStyle: {
                                  color: "#856404",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _vm._v(
                                  "Filtering Summary (Click to " +
                                    _vm._s(
                                      _vm.showFilteringReason ? "hide" : "show"
                                    ) +
                                    ")"
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#856404",
                                  "font-size": "12px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.showFilteringReason ? "▼" : "▶")
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm.showFilteringReason
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "8px" } },
                              [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      margin: "0",
                                      color: "#856404",
                                      "font-size": "13px",
                                      "line-height": "1.5",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.filteringReason))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.rankedGenes.length > 0
                  ? _c("div", { staticClass: "table-section" }, [
                      _vm._m(11),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-bottom": "10px",
                            display: "flex",
                            "justify-content": "flex-end",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              staticStyle: {
                                padding: "6px 12px",
                                "font-size": "13px",
                              },
                              attrs: {
                                disabled: _vm.selectedRankedGenes.length === 0,
                              },
                              on: { click: _vm.downloadRankedGenes },
                            },
                            [_vm._v(" Download Selected Genes ")]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "table-container" }, [
                        _c("table", { staticClass: "gene-data-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "40px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "selectAllRankedGenesCheckbox",
                                    attrs: {
                                      type: "checkbox",
                                      indeterminate:
                                        _vm.someRankedGenesSelected(),
                                    },
                                    domProps: {
                                      checked: _vm.allRankedGenesSelected(),
                                    },
                                    on: { change: _vm.toggleAllRankedGenes },
                                  }),
                                ]
                              ),
                              _c("th", [_vm._v("Gene")]),
                              _c("th", [_vm._v("Classification")]),
                              _c("th", [_vm._v("Relevance Score")]),
                              _c("th", [_vm._v("Novelty Score")]),
                              _c("th", { staticStyle: { width: "30%" } }, [
                                _vm._v("Reason"),
                              ]),
                              _c("th", { staticStyle: { width: "30%" } }, [
                                _vm._v("Hypothesis Validation"),
                              ]),
                              _c("th", [_vm._v("IDG Novelty")]),
                              _c("th", [_vm._v("IDG Evidence")]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.rankedGenesTableRows, function (row) {
                                return [
                                  row.type === "candidate"
                                    ? _c(
                                        "tr",
                                        {
                                          key: `candidate-${row.index}`,
                                          class: {
                                            "selected-row":
                                              _vm.isRankedGeneSelected(
                                                row.index
                                              ),
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "10px 8px",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                                "text-align": "center",
                                              },
                                            },
                                            [
                                              _c("input", {
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked:
                                                    _vm.isRankedGeneSelected(
                                                      row.index
                                                    ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.toggleRankedGeneSelection(
                                                      row.index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                color: "#333",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.candidate.gene || "N/A"
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticStyle: { color: "#666" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.candidate
                                                    .classification || "N/A"
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                color: "#666",
                                              },
                                            },
                                            [
                                              row.candidate.relevance_score !==
                                                undefined &&
                                              row.candidate.relevance_score !==
                                                null &&
                                              row.candidate.relevance_score !==
                                                "N/A"
                                                ? _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        "high-score":
                                                          (typeof row.candidate
                                                            .relevance_score ===
                                                          "number"
                                                            ? row.candidate
                                                                .relevance_score
                                                            : parseFloat(
                                                                row.candidate
                                                                  .relevance_score
                                                              )) >= 7,
                                                      },
                                                      staticStyle: {
                                                        "font-weight": "600",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.candidate
                                                              .relevance_score
                                                          ) +
                                                          _vm._s(
                                                            typeof row.candidate
                                                              .relevance_score ===
                                                              "number" ||
                                                              (typeof row
                                                                .candidate
                                                                .relevance_score ===
                                                                "string" &&
                                                                !isNaN(
                                                                  parseFloat(
                                                                    row
                                                                      .candidate
                                                                      .relevance_score
                                                                  )
                                                                ))
                                                              ? "/10"
                                                              : ""
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [_vm._v("N/A")]),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                color: "#666",
                                              },
                                            },
                                            [
                                              row.candidate.novelty_score !==
                                                undefined &&
                                              row.candidate.novelty_score !==
                                                null &&
                                              row.candidate.novelty_score !==
                                                "N/A"
                                                ? _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        "high-score":
                                                          (typeof row.candidate
                                                            .novelty_score ===
                                                          "number"
                                                            ? row.candidate
                                                                .novelty_score
                                                            : parseFloat(
                                                                row.candidate
                                                                  .novelty_score
                                                              )) >= 7,
                                                      },
                                                      staticStyle: {
                                                        "font-weight": "600",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.candidate
                                                              .novelty_score
                                                          ) +
                                                          _vm._s(
                                                            typeof row.candidate
                                                              .novelty_score ===
                                                              "number" ||
                                                              (typeof row
                                                                .candidate
                                                                .novelty_score ===
                                                                "string" &&
                                                                !isNaN(
                                                                  parseFloat(
                                                                    row
                                                                      .candidate
                                                                      .novelty_score
                                                                  )
                                                                ))
                                                              ? "/10"
                                                              : ""
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [_vm._v("N/A")]),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                color: "#666",
                                                "line-height": "1.5",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.candidate.reason || "N/A"
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                color: "#666",
                                                "line-height": "1.5",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.candidate
                                                    .hypothesis_validation ||
                                                    "N/A"
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                color: "#666",
                                              },
                                            },
                                            [
                                              row.candidate.idg_tdl
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: _vm.getTDLClass(
                                                          row.candidate.idg_tdl
                                                        ),
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          padding: "4px 10px",
                                                          "border-radius":
                                                            "4px",
                                                          "font-weight": "600",
                                                          "font-size": "11px",
                                                          color: "white",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            row.candidate
                                                              .idg_tdl
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : row.candidate.idg_tdl ===
                                                  undefined
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [_vm._v("Loading...")]
                                                  )
                                                : _c("span", [_vm._v("N/A")]),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "10px 8px",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                                "text-align": "center",
                                              },
                                            },
                                            [
                                              row.candidate.idg_fullData
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "idg-view-button",
                                                      class: {
                                                        active:
                                                          _vm.expandedRankedGenesIDG.includes(
                                                            row.candidate.gene
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleRankedGeneIDGEvidenceView(
                                                            row.candidate.gene
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.expandedRankedGenesIDG.includes(
                                                              row.candidate.gene
                                                            )
                                                              ? "Hide"
                                                              : "View"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : row.candidate.idg_fullData ===
                                                  undefined
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("Loading...")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("N/A")]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : row.type === "idg-evidence"
                                    ? _c(
                                        "tr",
                                        { key: `idg-evidence-${row.index}` },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "0",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                              },
                                              attrs: { colspan: 9 },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "idg-evidence-subtable",
                                                },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass:
                                                        "idg-evidence-table",
                                                    },
                                                    [
                                                      _vm._m(12, true),
                                                      _c("tbody", [
                                                        _c("tr", [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.candidate
                                                                  .idg_fullData
                                                                  .sym || "N/A"
                                                              )
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.candidate
                                                                  .idg_fullData
                                                                  .name || "N/A"
                                                              )
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.candidate
                                                                  .idg_fullData
                                                                  .fam || "N/A"
                                                              )
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            row.candidate
                                                              .idg_fullData.tdl
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    class:
                                                                      _vm.getTDLClass(
                                                                        row
                                                                          .candidate
                                                                          .idg_fullData
                                                                          .tdl
                                                                      ),
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "inline-block",
                                                                        padding:
                                                                          "4px 10px",
                                                                        "border-radius":
                                                                          "4px",
                                                                        "font-weight":
                                                                          "600",
                                                                        "font-size":
                                                                          "11px",
                                                                        color:
                                                                          "white",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          row
                                                                            .candidate
                                                                            .idg_fullData
                                                                            .tdl
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                          ]),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "max-width":
                                                                  "400px",
                                                                "word-wrap":
                                                                  "break-word",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.candidate
                                                                    .idg_fullData
                                                                    .description ||
                                                                    "N/A"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.candidate
                                                                  .idg_fullData
                                                                  .novelty !==
                                                                  null &&
                                                                  row.candidate
                                                                    .idg_fullData
                                                                    .novelty !==
                                                                    undefined
                                                                  ? row
                                                                      .candidate
                                                                      .idg_fullData
                                                                      .novelty
                                                                  : "N/A"
                                                              )
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            row.candidate
                                                              .idg_fullData.sym
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#FF6600",
                                                                        "text-decoration":
                                                                          "none",
                                                                        "font-weight":
                                                                          "600",
                                                                      },
                                                                    attrs: {
                                                                      href: `https://pharos.nih.gov/targets/${row.candidate.idg_fullData.sym}`,
                                                                      target:
                                                                        "_blank",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Open "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                          ]),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm.rankedGenesTotalPages > 1
                        ? _c("div", { staticClass: "pagination-container" }, [
                            _c("div", { staticClass: "pagination-info" }, [
                              _vm._v(
                                " Showing " +
                                  _vm._s(
                                    (_vm.rankedGenesCurrentPage - 1) *
                                      _vm.itemsPerPage +
                                      1
                                  ) +
                                  " to " +
                                  _vm._s(
                                    Math.min(
                                      _vm.rankedGenesCurrentPage *
                                        _vm.itemsPerPage,
                                      _vm.rankedGenes.length
                                    )
                                  ) +
                                  " of " +
                                  _vm._s(_vm.rankedGenes.length) +
                                  " entries "
                              ),
                            ]),
                            _c("div", { staticClass: "pagination-controls" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled: _vm.rankedGenesCurrentPage === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToRankedGenesPage(1)
                                    },
                                  },
                                },
                                [_vm._v(" «« ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled: _vm.rankedGenesCurrentPage === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToRankedGenesPage(
                                        _vm.rankedGenesCurrentPage - 1
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Previous ")]
                              ),
                              _c(
                                "span",
                                { staticClass: "page-numbers" },
                                _vm._l(
                                  _vm.visibleRankedGenesPages,
                                  function (page) {
                                    return _c(
                                      "button",
                                      {
                                        key: page,
                                        class: [
                                          "page-btn",
                                          {
                                            active:
                                              page ===
                                              _vm.rankedGenesCurrentPage,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToRankedGenesPage(page)
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(page) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled:
                                      _vm.rankedGenesCurrentPage ===
                                      _vm.rankedGenesTotalPages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToRankedGenesPage(
                                        _vm.rankedGenesCurrentPage + 1
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Next ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled:
                                      _vm.rankedGenesCurrentPage ===
                                      _vm.rankedGenesTotalPages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToRankedGenesPage(
                                        _vm.rankedGenesTotalPages
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" »» ")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.rankedGenes.length === 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          padding: "20px",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { disabled: _vm.isRankingGenes },
                            on: { click: _vm.handleRankGenes },
                          },
                          [
                            _vm.isRankingGenes
                              ? _c("span", {
                                  staticClass: "loading-spinner-small",
                                })
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.isRankingGenes
                                    ? "Ranking..."
                                    : "Rank Genes"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "dialog-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: { click: _vm.closeRankDialog },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm.showGroupDialog
      ? _c(
          "div",
          {
            staticClass: "dialog-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeGroupDialog.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "dialog-container" }, [
              _c("div", { staticClass: "dialog-header" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.showOnlyGroupAndTier
                        ? "Group and Tier Genes (Optional)"
                        : "Group and Tier Selected Genes"
                    )
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: { click: _vm.closeGroupDialog },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _c("div", { staticClass: "dialog-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "research-context-section",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _vm._m(13),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.researchContext ||
                              "No research context provided"
                          )
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-section",
                    staticStyle: {
                      "margin-bottom": "20px",
                      padding: "15px",
                      background: "#f8f9fa",
                      "border-radius": "6px",
                    },
                  },
                  [
                    _c("h4", [_vm._v("Hypothesis")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.hypothesis || "No hypothesis provided")
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-section",
                    staticStyle: {
                      "margin-bottom": "20px",
                      padding: "15px",
                      background: "#f8f9fa",
                      "border-radius": "6px",
                    },
                  },
                  [
                    _c("h4", [
                      _vm._v(
                        "Selected Genes (" +
                          _vm._s(_vm.selectedGenes.length) +
                          ")"
                      ),
                    ]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          margin: "0",
                          color: "#666",
                          "font-size": "14px",
                          "line-height": "1.6",
                        },
                      },
                      [_vm._v(_vm._s(_vm.selectedGenes.join(", ")))]
                    ),
                  ]
                ),
                _vm.isGroupingGenes
                  ? _c(
                      "div",
                      {
                        staticClass: "loading-indicator",
                        staticStyle: {
                          "margin-bottom": "20px",
                          padding: "12px",
                          background: "#e3f2fd",
                          "border-left": "3px solid #1976d2",
                          "border-radius": "4px",
                        },
                      },
                      [
                        _c("span", { staticClass: "loading-spinner-small" }),
                        _c("span", [
                          _vm._v(
                            "Grouping and tiering genes... (" +
                              _vm._s(_vm.groupElapsedTime) +
                              ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.groupedGenes && !_vm.isGroupingGenes
                  ? _c(
                      "div",
                      {
                        staticClass: "grouped-results",
                        staticStyle: { "margin-bottom": "20px" },
                      },
                      [
                        _vm.groupedGenes.summary
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "20px",
                                  padding: "15px",
                                  background: "#e3f2fd",
                                  "border-left": "3px solid #1976d2",
                                  "border-radius": "4px",
                                },
                              },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticStyle: {
                                      margin: "0 0 10px 0",
                                      color: "#1976d2",
                                      "font-size": "16px",
                                    },
                                  },
                                  [_vm._v("Summary")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      margin: "0",
                                      color: "#333",
                                      "font-size": "14px",
                                      "line-height": "1.6",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.groupedGenes.summary))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._l(_vm.groupedGenes.tiers, function (tier) {
                          return _c(
                            "div",
                            {
                              key: tier.tier,
                              staticClass: "tier-section",
                              staticStyle: {
                                "margin-bottom": "25px",
                                padding: "20px",
                                background: "#ffffff",
                                border: "1px solid #dee2e6",
                                "border-radius": "8px",
                                "box-shadow": "0 2px 4px rgba(0,0,0,0.05)",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tier-header",
                                  staticStyle: {
                                    "margin-bottom": "15px",
                                    "padding-bottom": "10px",
                                    "border-bottom": "2px solid #dee2e6",
                                  },
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticStyle: {
                                        margin: "0",
                                        color: "#333",
                                        "font-size": "18px",
                                        "font-weight": "600",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " Tier " +
                                          _vm._s(tier.tier) +
                                          ": " +
                                          _vm._s(tier.tierName) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  tier.rationale
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            margin: "8px 0 0 0",
                                            color: "#666",
                                            "font-size": "14px",
                                            "line-height": "1.5",
                                          },
                                        },
                                        [_vm._v(_vm._s(tier.rationale))]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._l(tier.groups, function (group, groupIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: groupIndex,
                                    staticClass: "group-item",
                                    staticStyle: {
                                      "margin-bottom": "20px",
                                      padding: "15px",
                                      background: "#f8f9fa",
                                      "border-radius": "6px",
                                      "border-left": "4px solid #28a745",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "align-items": "flex-start",
                                          "flex-wrap": "wrap",
                                          gap: "8px",
                                        },
                                      },
                                      [
                                        _c(
                                          "h5",
                                          {
                                            staticStyle: {
                                              margin: "0 0 10px 0",
                                              color: "#28a745",
                                              "font-size": "16px",
                                              "font-weight": "600",
                                            },
                                          },
                                          [_vm._v(_vm._s(group.groupName))]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-outline-secondary",
                                            staticStyle: {
                                              "font-size": "12px",
                                              padding: "4px 10px",
                                            },
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleGroupForProtocol(
                                                  tier,
                                                  group
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  group.selectedForProtocol !==
                                                    false
                                                    ? "Unselect group"
                                                    : "Select group"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "strong",
                                          {
                                            staticStyle: {
                                              color: "#333",
                                              "font-size": "13px",
                                            },
                                          },
                                          [_vm._v("Genes:")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-wrap": "wrap",
                                              gap: "6px",
                                              "margin-top": "6px",
                                            },
                                          },
                                          _vm._l(group.genes, function (gene) {
                                            return _c(
                                              "span",
                                              {
                                                key: gene,
                                                staticStyle: {
                                                  display: "inline-block",
                                                  padding: "4px 10px",
                                                  background: "#28a745",
                                                  color: "white",
                                                  "border-radius": "12px",
                                                  "font-size": "12px",
                                                  "font-weight": "500",
                                                },
                                              },
                                              [_vm._v(" " + _vm._s(gene) + " ")]
                                            )
                                          }),
                                          0
                                        ),
                                      ]
                                    ),
                                    group.groupingRationale
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticStyle: {
                                                  color: "#333",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [_vm._v("Grouping Rationale:")]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  margin: "6px 0 0 0",
                                                  color: "#666",
                                                  "font-size": "13px",
                                                  "line-height": "1.5",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    group.groupingRationale
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    group.experimentalApproach
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticStyle: {
                                                  color: "#333",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [_vm._v("Experimental Approach:")]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  margin: "6px 0 0 0",
                                                  color: "#666",
                                                  "font-size": "13px",
                                                  "line-height": "1.5",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    group.experimentalApproach
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          gap: "20px",
                                          "margin-top": "10px",
                                          "padding-top": "10px",
                                          "border-top": "1px solid #dee2e6",
                                        },
                                      },
                                      [
                                        group.estimatedResources
                                          ? _c("div", [
                                              _c(
                                                "strong",
                                                {
                                                  staticStyle: {
                                                    color: "#333",
                                                    "font-size": "12px",
                                                  },
                                                },
                                                [_vm._v("Resources:")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#666",
                                                    "font-size": "12px",
                                                    "margin-left": "6px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      group.estimatedResources
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        group.estimatedTimeline
                                          ? _c("div", [
                                              _c(
                                                "strong",
                                                {
                                                  staticStyle: {
                                                    color: "#333",
                                                    "font-size": "12px",
                                                  },
                                                },
                                                [_vm._v("Timeline:")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#666",
                                                    "font-size": "12px",
                                                    "margin-left": "6px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      group.estimatedTimeline
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "dialog-actions" }, [
                _vm.groupedGenes && !_vm.isGroupingGenes
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.reviewAndGenerateWithSelectedGroups },
                      },
                      [
                        _vm._v(
                          " Review & Generate Experiment Plan with Selected Groups "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: { click: _vm.closeGroupDialog },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tooltip tooltip-score" }, [
      _c("div", { staticClass: "tooltip-content" }, [
        _c("h5", [_vm._v("Gene Relevance & Novelty Scoring")]),
        _c("p", [
          _c("strong", [_vm._v("What it does:")]),
          _vm._v(
            " Scores each gene for relevance and novelty based on your hypothesis and research context."
          ),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Relevance Score (1-10):")]),
          _vm._v(
            " Measures mechanistic linkage between the gene's function and your hypothesis, with explicit reference to relevant tissue(s)."
          ),
        ]),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("2:")]),
            _vm._v(" Weak/indirect mechanism; unclear tissue link"),
          ]),
          _c("li", [
            _c("strong", [_vm._v("5:")]),
            _vm._v(" Plausible mechanism with partial support"),
          ]),
          _c("li", [
            _c("strong", [_vm._v("8:")]),
            _vm._v(" Strong mechanism with multiple evidence lines"),
          ]),
          _c("li", [
            _c("strong", [_vm._v("10:")]),
            _vm._v(" Direct, specific mechanism in exact tissue(s)"),
          ]),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Novelty Score (1-10):")]),
          _vm._v(
            " Measures context-specific newness - how much testing this gene would yield new insight beyond well-trodden literature."
          ),
        ]),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("2:")]),
            _vm._v(" Heavily characterized core component"),
          ]),
          _c("li", [
            _c("strong", [_vm._v("5:")]),
            _vm._v(" Studied gene with limited work in this context"),
          ]),
          _c("li", [
            _c("strong", [_vm._v("8:")]),
            _vm._v(" Clear context-specific novelty"),
          ]),
          _c("li", [
            _c("strong", [_vm._v("10:")]),
            _vm._v(" Highly novel with little/no direct prior work"),
          ]),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Output:")]),
          _vm._v(
            " For each gene, provides classification, relevance score, novelty score, novelty basis (Tissue-Specific/Mechanistic/Contextual), reason, and hypothesis validation suggestions."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tooltip tooltip-rank" }, [
      _c("div", { staticClass: "tooltip-content" }, [
        _c("h5", [_vm._v("Filter, Score, and Rank Genes")]),
        _c("p", [
          _c("strong", [_vm._v("What it does:")]),
          _vm._v(
            " A two-step process that first filters genes, then scores and ranks the filtered set."
          ),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Step 1 - Filtering:")]),
          _vm._v(
            " Pre-filters genes based on relevance and novelty criteria, selecting genes that:"
          ),
        ]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "Are mechanistically relevant to the hypothesis (relevance score ≥5)"
            ),
          ]),
          _c("li", [_vm._v("Align with the research context")]),
          _c("li", [_vm._v("Have clear tissue links")]),
          _c("li", [
            _vm._v(
              "Meet novelty considerations (excludes well-studied core components unless they have Contextual Novelty)"
            ),
          ]),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Step 2 - Ranking:")]),
          _vm._v(
            " Scores and ranks all filtered genes using the same scoring criteria as the scoring function, then orders them by combined relevance and novelty scores."
          ),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Output:")]),
          _vm._v(
            " A ranked list of filtered genes with scores, classifications, reasons, and hypothesis validation suggestions, sorted by combined score (highest first)."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("What it does:")]),
      _vm._v(
        " Groups selected genes that can be experimented together and organizes them into tiers for experiment workflows."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Grouping:")]),
      _vm._v(
        " Identifies genes that share common experimental approaches, pathways, or mechanisms, making them suitable for combined experiments."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Tiering:")]),
      _vm._v(" Organizes gene groups into priority tiers based on:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("Experimental feasibility and resource requirements")]),
      _c("li", [_vm._v("Scientific priority and impact potential")]),
      _c("li", [_vm._v("Dependencies between experiments")]),
      _c("li", [_vm._v("Workflow efficiency")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Output:")]),
      _vm._v(
        " A structured JSON response with gene groups organized by tiers, including rationale for grouping and tier assignments."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [
        _vm._v("Research Context "),
        _c(
          "span",
          { staticStyle: { color: "#666", "font-weight": "normal" } },
          [_vm._v("(Optional)")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "tdl-legend",
        staticStyle: {
          "margin-bottom": "15px",
          padding: "12px 15px",
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          "border-radius": "6px",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "margin-bottom": "8px",
              "font-weight": "600",
              color: "#333",
              "font-size": "13px",
            },
          },
          [_vm._v("Target Development Level (TDL) Classification:")]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-wrap": "nowrap",
              gap: "12px 20px",
              "font-size": "12px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tclin",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#007bff",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tclin")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Targets of approved drugs"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tchem",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#17a2b8",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tchem")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Bind small molecules with high potency"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tbio",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#fd7e14",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tbio")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Linked to biological processes relevant to disease"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tdark",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#dc3545",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tdark")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v(
                    "No clinical, chemical, or biological links to disease"
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Gene")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Family")]),
        _c("th", [_vm._v("TDL")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Novelty")]),
        _c("th", [_vm._v("Visit Pharos")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [
        _vm._v("Research Context "),
        _c(
          "span",
          { staticStyle: { color: "#666", "font-weight": "normal" } },
          [_vm._v("(Optional)")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "tdl-legend",
        staticStyle: {
          "margin-bottom": "15px",
          padding: "12px 15px",
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          "border-radius": "6px",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "margin-bottom": "8px",
              "font-weight": "600",
              color: "#333",
              "font-size": "13px",
            },
          },
          [_vm._v("Target Development Level (TDL) Classification:")]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-wrap": "nowrap",
              gap: "12px 20px",
              "font-size": "12px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tclin",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#007bff",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tclin")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Targets of approved drugs"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tchem",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#17a2b8",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tchem")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Bind small molecules with high potency"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tbio",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#fd7e14",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tbio")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Linked to biological processes relevant to disease"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tdark",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#dc3545",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tdark")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v(
                    "No clinical, chemical, or biological links to disease"
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Gene")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Family")]),
        _c("th", [_vm._v("TDL")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Novelty")]),
        _c("th", [_vm._v("Visit Pharos")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [
        _vm._v("Research Context "),
        _c(
          "span",
          { staticStyle: { color: "#666", "font-weight": "normal" } },
          [_vm._v("(Optional)")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }